export const STATS_ICONS = {
  chart: "/images/Chart_increasing.png",
  people: "/images/Student.png",
  target: "/images/Bullseye.png",
  money: "/images/Money_bag.png",
  fire: "/images/Heart_on_fire.png",
  party: "/images/Party_popper.png",
  sad: "/images/Loudly_crying_face.png",
  crown: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Crown.png",
  star: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Travel%20and%20places/Star.png",
  memo: "/images/Memo.png"
};
